import ReactOnRails from 'react-on-rails';
import Footer from '../../bundles/Footer/components/Footer.jsx';

ReactOnRails.register({Footer});
